export type EntryReducer = {
  email: string;
  password: string;
  challengeResponse: string | null;
  error: string;
};

export type EntryAction =
  | { type: "CLEAR" }
  | { type: "UPDATE_EMAIL"; email: string }
  | { type: "UPDATE_CHALLENGE_RESPONSE"; challengeResponse: string | null }
  | { type: "UPDATE_ERROR"; error: string };

const initialState: EntryReducer = {
  email: "",
  password: "",
  challengeResponse: null,
  error: "",
};

function entry(state = initialState, action: EntryAction): EntryReducer {
  switch (action.type) {
    case "CLEAR":
      return { ...initialState };
    case "UPDATE_EMAIL":
      return { ...state, email: action.email };
    case "UPDATE_CHALLENGE_RESPONSE":
      return { ...state, challengeResponse: action.challengeResponse };
    case "UPDATE_ERROR":
      return { ...state, error: action.error };
    default:
      return state;
  }
}

export default entry;
